import { db } from "../dexie";
import { InstanceOverride, InstanceOverrideRecord, instanceOverrideRecordSchema } from "../types";
import { Collection } from "../utils/collection";

export const Instances = {
  getByDateRange(dates: string[]) {
    return new Collection<InstanceOverride, InstanceOverrideRecord>(
      instanceOverrideRecordSchema,
      db.instances.where("date").anyOf(dates),
    );
  },
};
